module.exports = __webpack_public_path__ + "static/img/cctDriver.4ed75276.png";